import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import DocumentMeta from 'react-document-meta';
import Image from '../components/Image';
import {
  loadFestivalEventCategories,
  loadOrgsByType,
  loadFestivalNews,
  loadSponsors,
  loadFestivalSponsorsByCategory
} from '../actions';
import FestivalEventCard from '../components/festival/FestivalEventCard';
import Disclaimer from '../components/festival/Disclaimer';
import Modal, {closeStyle} from 'simple-react-modal';
import FestivalNews from '../components/festival/news/FestivalNews';
import GWEPromo from '../components/festival/gwe/GWEPromo';
import SponsorsList from '../components/festival/sponsors/SponsorsList';



const videoUrls = {
  '2018 ABC Bay Area Life': 'https://www.youtube.com/embed/HfRW9AzPor8?autoplay=1',

  '2017 Comcast Game On': 'https://www.youtube.com/embed/ghsXKA3q1Xw?autoplay=1',

  '2017 Baycat': 'https://www.youtube.com/embed/XPD3qEAkalc?autoplay=1',
  '2016 Comcast': 'https://www.youtube.com/embed/JRPUej909hU?autoplay=1',
  '2016 Competition': 'https://www.youtube.com/embed/SfGl7H1KVKc?autoplay=1',
  '2016 GlobalGirl': 'https://www.youtube.com/embed/y5EhrXjzIQo?autoplay=1'
}

class Festival extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    showVideo: false,
    videoUrl: ''
  }

  show = (urlKey, isModal) => {
    this.setState({
      videoUrl: videoUrls[urlKey],
      show: true
    });
  }

  close = () => {
    this.setState({show: false});
  }

  componentWillMount() {
    this.props.loadFestivalEventCategories();
    this.props.loadFestivalNews();
    this.props.loadOrgsByType({
      is_festival_exhibitor: true
    });
    this.props.loadSponsors();
    this.props.loadFestivalSponsorsByCategory({
      sponsor_category_name: 'Platinum'
    });
  }

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  render() {

    if (!this.props.girlsFestivalEventCategories.isLoaded) {
      return <span />;
    }

    if (!this.props.orgsByType.isLoaded) {
      return <span />;
    }

    if (!this.props.girlsFestivalSponsors.isLoaded) {
      return <span />;
    }

    if (!this.props.festivalSponsorsByCategory.isLoaded) {
      return <span />;
    }

    let browser = this.props.browser;
    let events = this.props.girlsFestivalEventCategories;

    // Get the Platinum sponsors
    let platinumSponsors = this.props.festivalSponsorsByCategory;
    let platinumSponsorLink;
    let platinumSponsorList = platinumSponsors.map((sponsor, idx) => {
      if (sponsor.sponsor_website_url != '') {
        platinumSponsorLink = <div className="platinumSponsors">
          <a href={sponsor.sponsor_website_url}><img src={sponsor.sponsor_logo} /></a>
        </div>;
      } else {
        platinumSponsorLink = <div className="platinumSponsors"><img src={sponsor.sponsor_logo} /></div>;
      }
      return <div className="platinumSponsorsWrapper">
        {platinumSponsorLink}
      </div>;
    });

    // Get all the current sponsors
    let sponsors = this.props.girlsFestivalSponsors;

    let bannerWrapper;
    if (this.props.browser.greaterThan.tablet) {
      bannerWrapper = <div className="festivalHome-bannerWrapper">
        <div className="festivalHome-bannerWrapperInner">
          <iframe style={{ border: 0 }} frameborder="0" height="408" width="1676"
            src="https://www.youtube.com/embed/7KTqQwq0Ruk?autoplay=1&controls=0&showinfo=0&autohide=1&loop=1&mute=1&playlist=7KTqQwq0Ruk">
          </iframe>


        </div>

        <div className="festivalHome-bannerOverlayWrapper">
          <div className="festivalHome-bannerOverlayWrapperInner">
            <Link to="/girls-festival/tickets"><div className="festivalHome-bannerOverlayCopy">
              &nbsp;
            </div></Link>


          </div>


        </div>

        <div className="festivalHome-tagline">
          <div className="festivalHome-taglineCopy">
            November 9th, 2019 &bull; Palace of Fine Arts &bull; San Francisco
          </div>
        </div>
      </div>;

    } else {
      bannerWrapper = <img style={{ width: '100%' }} className="mobile" src="/images/festival/home/2019/gf_banner_mobile_01.jpg" />;
    }


    let eventCard = '';

    let eventCategories = events.map((event, index) => {
      if (browser.greaterThan.phablet) {
        eventCard = <FestivalEventCard
          browser = {this.props.browser}
          event = {event}
          viewPort = 'desktop'
          imgSrc = {event.event_image_desktop}
        />;
      } else {
        eventCard = <FestivalEventCard
          browser = {this.props.browser}
          event = {event}
          viewPort = 'mobile'
          imgSrc = {event.event_image_mobile}
        />;
      }
      return eventCard;
    })

    let iframe = '';
    let modalContentStyle = '';
    let closeIcon = '';
    let videoUrl = this.state.videoUrl;
    let isModal = this.state.isModal;


    if (this.props.browser.greaterThan.desktop) {

      modalContentStyle = {
        width: '900px',
        height: '707px',
        backgroundColor: 'transparent'
      }

      iframe = <iframe width='900' height='507' src={videoUrl}



       frameBorder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>

    } else {

      modalContentStyle = {
        paddingBottom: '56.25%',
        width: '100%',
        backgroundColor: 'transparent'
      }

      closeIcon = <div style={{position: 'absolute', top: '-4px', right: '44px'}} onClick={this.close.bind(this)}><img src={'/images/transparent_close.png'}/></div>

      iframe = <iframe style={{position: 'absolute', top: '44px', left: '0', width: '100%', height: '100%'}} src={videoUrl} frameBorder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    }


    return(
      <div>
        <Modal

          containerStyle={modalContentStyle}
          closeOnOuterClick={true}
          show={this.state.show}
          onClose={this.close.bind(this)}
          transitionSpeed={1000}>

          <a key="close" style={closeStyle} onClick={this.close.bind(this)}>X</a>

          <div key="content">
            {closeIcon}
            <div >
              {iframe}
            </div>
          </div>

        </Modal>

        {bannerWrapper}


        <div className="content-wrapper">
          <div className="headerTagWrapper">
          <h1 className="page-heading">A day of power and possibility &ndash; and fun &ndash; for girls!</h1>

          <p>Join us at our 4th annual Girls' Festival on November 9th at the enormous and iconic Palace of Fine Arts in San Francisco. We are expecting over 7,000 girls and their families to attend from the greater SF Bay Area and, this year, from around the country. Through our recent merger with Girls World Expo, we have created a national program of events for 100,000 girls in 20+ cities throughout the United States.</p>

          <p>This year we will host close to 100 engaging activities throughout the day ( see below) all geared to connect girls to important resources to help them thrive, bolster their self-esteem, and inspire them to reach for the stars !</p>

          </div>

          <div className="eventCategoriesWrapper">
            {eventCategories}
          </div>

          <div className="festival-gwePromoWrapperOuter">
            <GWEPromo
              browser = {this.props.browser}
            />
          </div>

          <div className="festivalNewsWrapper">
            <FestivalNews
              browser = {this.props.browser}
              festivalNews = {this.props.festivalNews}
            />
          </div>

          <div className="videoWrapperOuter">
            <div className="headerWrapper">
              <h2 className="page-heading">Videos from our past events</h2>

            </div>

            <div className="videos row-2018">

              <div className="video-wrapper">
                <div onClick={this.show.bind(this, '2018 ABC Bay Area Life', true)} className="videoImg">
                  <img className="desktop" src="/images/festival/home/video_thumbs/desktop/2018/abc_bay_area_life_video.jpg" />
                  <img className="mobile" src="/images/festival/home/video_thumbs/mobile/2018/abc_bay_area_life_video.jpg" />
                </div>
                <div className="videoCaption">
                  ABC7 News Bay Area LIFE segment
                </div>
              </div>

              <div className="video-wrapper video-wrapper-last">
                <div className="videoImg"><a href="https://abc7news.com/society/bay-area-life-3rd-annual-girls-festival/4380287/" target="_blank">
                  <img className="desktop" src="/images/festival/home/video_thumbs/desktop/2018/abc_bay_all_about_video.jpg" />
                  <img className="mobile" src="/images/festival/home/video_thumbs/mobile/2018/abc_bay_all_about_video.jpg" /></a>
                </div>
                <div className="videoCaption">
                  ABC7 News: All About the Girls' Festival
                </div>
              </div>

              <div className="video-wrapper video-wrapper-last">
                <div className="videoImg"><a href="https://abc7news.com/society/bay-area-life-3rd-annual-girls-festival/4380287/" target="_blank">
                  <img className="desktop" src="/images/festival/home/video_thumbs/desktop/2018/abc_bay_all_about_video.jpg" />
                  <img className="mobile" src="/images/festival/home/video_thumbs/mobile/2018/abc_bay_all_about_video.jpg" /></a>
                </div>
                <div className="videoCaption">
                  ABC7 News: All About the Girls' Festival
                </div>
              </div>

            </div>

            <div className="videos row-2018">

              <div className="video-wrapper">
                <div onClick={this.show.bind(this, '2017 Comcast Game On', true)} className="videoImg">
                  <img className="desktop" src="/images/festival/home/video_thumbs/desktop/2017/2017_comcast_game_on.jpg" />
                  <img className="mobile" src="/images/festival/home/video_thumbs/mobile/2017/2017_comcast_game_on.jpg" />
                </div>
                <div className="videoCaption">
                  Comcast's Game On Recap of the 2017 Festival
                </div>
              </div>

              <div className="video-wrapper video-wrapper-last">
                <div onClick={this.show.bind(this, '2016 Competition', true)} className="videoImg">
                  <img className="desktop" src="/images/festival/home/video_thumbs/desktop/2016/2016_bizworld.jpg" />
                  <img className="mobile" src="/images/festival/home/video_thumbs/mobile/2016/2016_bizworld.jpg" />
                </div>
                <div className="videoCaption">
                  BizWorld Girlpreneur Competition with Tim Draper, Mark Cuban &amp; Sue Siegel
                </div>
              </div>

              <div className="video-wrapper video-wrapper-last">
                <div onClick={this.show.bind(this, '2016 Comcast', true)} className="videoImg">
                  <img className="desktop" src="/images/festival/home/video_thumbs/desktop/2016/2016_comcast_game_on.jpg" />
                  <img className="mobile" src="/images/festival/home/video_thumbs/mobile/2016/2016_comcast_game_on.jpg" />
                </div>
                <div className="videoCaption">
                  Comcast's Game On Recap of the 2016 Festival
                </div>
              </div>

            </div>

          </div>

          <div className="sponsorsOuterWrapper">
            <h2 className="page-heading">Thank you to our national sponsors!</h2>
            {platinumSponsorList}

            <SponsorsList
              sponsors = {sponsors}
              browser = {this.props.browser}
            />
          </div>




        </div>

      </div>
    )
  }
};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    loadFestivalEventCategories,
    loadFestivalNews,
    loadOrgsByType,
    loadSponsors,
    loadFestivalSponsorsByCategory,
  }
)(Festival);



// WEBPACK FOOTER //
// ./src/containers/Festival.jsx